export default "dist/images/block-call-to-action-plain.d2b47c7.png";